import React from "react"
// import { Link, useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import { LinkDetect } from "utils/LinkDetect"
import Button from "components/shared/Button"

const WPLink = (props) => {
	const link = LinkDetect(props.url)
	const content = props.title || props.children
	const onClick = props.onClick ? props.onClick : () => {}

	// Check if internal link
	if (link.type === "internal") {
		if (props.button) {
			if (props.target === "_blank") {
				// styled button
				return (
					<Button as="a" href={link.url} color={props.color} className={props.className} onClick={onClick} target={props.target} rel="noopener noreferrer">
						{content}
					</Button>
				)
			} else {
				// styled button
				return (
					<Button as={Link} to={link.url} color={props.color} className={props.className} onClick={onClick} >
						{content}
					</Button>
				)
			}

		} else {
			// simple link
			if (props.target === "_blank") {
				return (
					<a href={link.url} className={props.className} onClick={onClick} target="_blank" rel="noopener noreferrer">
						{content}
					</a>
				)
			} else {
				return (
					<Link to={link.url} className={props.className} onClick={onClick}>
						{content}
					</Link>
				)
			}
		}
	} else {
		if (props.button) {
			// styled button with target
			return (
				<Button href={props.url} target="_blank" rel="noopener noreferrer" color={props.color} className={props.className} onClick={onClick}>
					{content}
				</Button>
			)
		} else {
			// simple link with target
			return (
				<a href={props.url} target="_blank" rel="noopener noreferrer" className={props.className} onClick={onClick}>
					{content}
				</a>
			)
		}
	}
}

WPLink.defaultProps = {
  button: false
}

export default WPLink